import React from 'react';

const AOWeRecommendSmile = (props) => {
	const { width, height, fill } = props;

	return (
		<svg
			width={width || '537'}
			height={height || '425'}
			viewBox="0 0 537 425"
			{...props}>
			<title>4A61DECC-C3DB-4DA4-A757-1B0F1B802D40@1.00x</title>
			<g
				id="🇬🇧-Mobile"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd">
				<g
					id="We-Recommend-smile"
					transform="translate(-43.000000, -47.000000)"
					fill={fill || '#14C35A'}
					fillRule="nonzero">
					<path
						d="M637.026404,169 L580.239515,169 C571.079569,169.011221 563.228176,175.71376 561.558419,184.947587 C543.545046,281.1232 461.035608,353.758621 362,353.758621 C262.964392,353.758621 180.424602,281.092083 162.441581,184.947587 C160.761078,175.737629 152.92984,169.054482 143.790837,169.031118 L86.9735955,169.031118 C81.4517992,169.029914 76.2035562,171.495518 72.5991081,175.784195 C68.9946599,180.072872 67.391808,185.7589 68.209034,191.357738 C89.3409806,338.246676 212.831979,451 362,451 C511.168021,451 634.659019,338.246676 655.790966,191.326621 C656.608192,185.727783 655.00534,180.041755 651.400892,175.753077 C647.796444,171.4644 642.548201,169 637.026404,169 Z"
						id="Path-Copy"
						transform="translate(362.000000, 310.000000) rotate(-30.000000) translate(-362.000000, -310.000000) "></path>
				</g>
			</g>
		</svg>
	);
};

export default AOWeRecommendSmile;
